import React__default, { useState, useEffect } from 'react';
import { debounce } from 'lodash-es';
import 'clsx';
import './../../../assets/src/components/util/NoStyleButton.css.ts.vanilla-9a05fce1.css';
import './../../../assets/src/components/util/NoStyleLink.css.ts.vanilla-7b419b33.css';
import Spacer from '../../util/Spacer/Spacer.js';
import { PROGRESS_STEP, FULL_PROGRESS_PERCENTAGE } from '../constants.js';
import FileComponent from './FileComponent.js';

const FileContainer = ({ file, deleteFile, hasFileProcessing }) => {
    const [progressConfig, setProgressConfig] = useState({
        intervalId: 0,
        progress: PROGRESS_STEP
    });
    const [hovered, setHovered] = useState(false);
    const onMouseEnter = debounce(() => setHovered(true), 300);
    const onMouseLeave = debounce(() => setHovered(false), 300);
    useEffect(() => {
        if (file.uploaded) {
            setProgressConfig((prevProgressConfig) => ({
                ...prevProgressConfig,
                progress: FULL_PROGRESS_PERCENTAGE
            }));
        }
    }, [file.uploaded]);
    return (React__default.createElement(Spacer, { bottom: 8 },
        React__default.createElement("div", { onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
            React__default.createElement(FileComponent, { file: file, hovered: hovered, deleteFile: deleteFile, progressConfig: progressConfig, hasFileProcessing: hasFileProcessing, setProgress: setProgressConfig }))));
};

export { FileContainer };
//# sourceMappingURL=FileContainer.js.map
